export const homepageTabs = [
  { value: 'markets', label: 'Markets', labelMobile: 'Markets' },
  { value: 'orders', label: 'My orders', labelMobile: 'Orders' },
  { value: 'rewards', label: 'My rewards', labelMobile: 'Rewards' },
];

export const marketsTableHeading = [
  {
    label: 'bonds',
    isSortAvailable: true,
  },
  {
    label: 'lock periods',
  },
  {
    label: 'amount',
  },
  {
    label: 'value',
  },
  {
    label: 'difference',
  },
  {
    label: 'asking price',
  },
  {
    label: 'payment token',
  },
  {
    label: 'start date',
  },
];

export const ordersTableHeading = [
  {
    label: 'bonds',
  },
  { label: 'payment' },
  { label: 'amount' },
  { label: 'payout' },
  { label: 'time locked' },
  { label: 'tx hash' },
  { label: 'actions' },
];

export const txHistoryTableHeading = [
  {
    label: 'Date',
    isSortAvailable: true,
  },
  { label: 'bond amount' },
  { label: 'payout amount' },
  { label: 'discount' },
  { label: 'tx hash' },
  { label: 'address' },
];

export const ascending = 'ascending';
export const descending = 'descending';
export const transferSingle = 'TransferSingle';
export const bonded = 'Bonded';

export const vestingOptions =
  process.env.REACT_APP_CHAIN_ID !== '16718'
    ? [
        { label: '14 days', value: 1209600 },
        { label: '10 days', value: 864000 },
        { label: '8 days', value: 691200 },
        { label: '1 day', value: 86400 },
        { label: '2 hours', value: 7200 },
        { label: '1 hour', value: 3600 },
        { label: '30 min', value: 1800 },
        { label: '15 min', value: 900 },
        { label: '5 min', value: 300 },
        { label: '1 min', value: 60 },
      ]
    : [
        { label: '1 min', value: 60 },
        { label: '1 day', value: 86400 },
        { label: '3 days', value: 259200 },
        { label: '7 days', value: 604800 },
        { label: '10 day', value: 864000 },
        { label: '14 day', value: 1209600 },
        { label: '1 month', value: 2419200 },
        { label: '3 months', value: 7889231 },
        { label: '6 months', value: 15778463 },
        { label: '1 year', value: 31556926 },
      ];

export const FPA = 'FPA';
export const OFDA = 'OFDA';
export const SDA = 'SDA';
export const OSDA = 'OSDA';
export const FPDA = 'FPDA';

export const marketTypes = [
  { value: FPA, label: 'FPA (Fixed-term Price Auction)' },
  // { value: OFDA, label: 'OFDA (Oracle Fixed Discount Auction)' },
  { value: SDA, label: 'SDA (Sequential Dutch Auction)' },
  // { value: OSDA, label: 'OSDA (Oracle Sequential Dutch Auction)' },
  { value: FPDA, label: 'Kosmos' },
];

export const ORACLE_ADDRESS = 'oracleAddress';
export const PRICE_DISCOUNT = 'priceDiscount';
export const MAX_DISCOUNT = 'maxDiscount';
export const INITIAL_PRICE = 'initialPrice';
export const MINIMUM_PRICE = 'minimumPrice';
export const INITIAL_DISCOUNT = 'initialDiscount';
export const TARGET_INTERVAL_DISCOUNT = 'targetIntervalDiscount';
export const DEBT_BUFFER = 'debtBuffer';
export const DISCOUNT = 'discount';

export const fpaFields = {
  [DISCOUNT]: '',
};

export const ofdaFields = {
  [ORACLE_ADDRESS]: '',
  [PRICE_DISCOUNT]: '',
  [MAX_DISCOUNT]: '',
};

export const sdaFields = {
  [INITIAL_PRICE]: '',
  [MINIMUM_PRICE]: '',
  [DEBT_BUFFER]: 25,
};

export const osdaFields = {
  [ORACLE_ADDRESS]: '',
  [INITIAL_DISCOUNT]: '',
  [MAX_DISCOUNT]: '',
  [TARGET_INTERVAL_DISCOUNT]: '',
};

export const simpleFormFields = {
  [DISCOUNT]: '',
};

export const FIXED_TERM = 'FixedTerm';
export const FIXED_EXPIRY = 'FixedExpiry';

export const vestingTypes = [
  { value: FIXED_TERM, label: 'Fixed term' },
  { value: FIXED_EXPIRY, label: 'Fixed expiry' },
];

export const marketTypesDescr: any = {
  [FPA]:
    'FPA lets you buy/sell a set amount of tokens at a fixed price for a defined time.',
  [OFDA]:
    'This auction offers a fixed discount to an oracle price for purchasing a targeted amount of tokens.',
  [SDA]:
    'SDA starts with a high price and lowers it over time until it is bought or reaches a minimum price.',
  [OSDA]:
    'OSDA sells tokens in a straight line over time, adjusting the price based on how many tokens are sold compared to the initial supply.',
};

export const vestingTypesDescr: any = {
  [FIXED_TERM]:
    'Tokens become unlocked after a selected vesting period from the moment you acquire tokens in bond auctions.',
  [FIXED_EXPIRY]:
    'Tokens simultaneously after a specified period following the end of the bond auction. Vesting duration remains uniform for all users and starts after the bond auction concludes.',
};

export const chartIntervals = [
  { label: '1D', value: 86400000 },
  { label: '3D', value: 259200000 },
  { label: '7D', value: 604800000 },
  { label: '1M', value: 2629800000 },
  { label: '1Y', value: 31556952000 },
  { label: 'All', value: 0 },
];

export const createMarketTabs = [
  { label: 'Simple', labelMobile: 'Simple', value: 'simple' },
  { label: 'Advanced', labelMobile: 'Advanced', value: 'advanced' },
];

export const presaleWhitelist = ["630", "631", "632", "641"];
